import BaseError from './BaseError';

class InvalidAppIdError extends BaseError {
  constructor() {
    super('Please provide valid app ID.');
  }
}

export default InvalidAppIdError;
